import request from "@/utils/request";
export function getListByItemId(data) {
  return request({
    url: "/whg-park/api/theaterSeatRegistration/getListByItemId",
    method: "post",
    data: data
  });
}
export function generateSeat(data) {
  return request({
    url: "/whg-park/api/theaterSeatRegistration/generateSeat",
    method: "post",
    data: data
  });
}
export function changeSeatStatus(data) {
  return request({
    url: "/whg-park/api/theaterSeatRegistration/changeSeatStatus",
    method: "post",
    data: data
  });
}
export function changeAreaStatus(data) {
  return request({
    url: "/whg-park/api/theaterSeatRegistration/changeAreaStatus",
    method: "post",
    data: data
  });
}